import { UsersPage } from './UsersPage';
import { UserPage } from './UserPage';
import { AdminPage } from './AdminPage';
import { EnterEmail } from './EnterEmail';
import { SignupPage } from './SignupPage';
import { WipeDataPage } from './WipeDataPage';
import { LookupPage } from './LookupPage';

export const identity = {
  routes: [{
    component: UsersPage,
    path: '/users',
    exact: true,
  }, {
    component: UserPage,
    path: '/users/:accountId',
    exact: true,
  }, {
    component: WipeDataPage,
    path: '/users/:accountId/wipe',
    exact: true,
  }, {
    component: EnterEmail,
    path: '/admin',
    exact: true,
  }, {
    component: LookupPage,
    path: '/lookup',
    exact: true,
  }, {
    component: AdminPage,
    path: '/admin/:email',
    exact: true,
  }, {
    component: SignupPage,
    path: '/signup/:token',
    exact: true,
  }],
};
